export const ListQueryKey = 'activityQhConfigs';
export const DetailQueryKey = 'activityQhConfig';
export const Urls = {
  selectUrl: '/QhConfig/list',
  updateUrl: '/QhConfig/update',
  deleteUrl: '/QhConfig/delete',
  createUrl: '/QhConfig/create',
  detailUrl: '/QhConfig/detail'
};